import { ValidationErrors } from 'acscp/api/models/errorDetails';
import { Country } from 'acscp/api/models/country';
import React from 'react';
import { LocaleCode } from 'acscp/translations';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { CountryOfResidenceInput } from 'acscp/components/auth/countryOfResidenceInput';
import { StateOfResidenceInput } from 'acscp/components/auth/stateOfResidenceInput';
import { countryRequiresState } from 'acscp/components/common/helpers/countryHelper';

interface CountryAndStateOfResidenceInputsOwnProps {
    countryInputName: string;
    stateInputName: string;
    validationErrors: ValidationErrors | undefined;
    optionsAreLoading: boolean;
    countryOptions: Country[];
    namingLocale: LocaleCode;
    selectedCountry: Country | undefined;
    selectedStateId: string;
    onChange: (country: Country | undefined, stateId: string) => void;
}

type CountryAndStateOfResidenceInputsProps = InjectedIntlProps & CountryAndStateOfResidenceInputsOwnProps;

const CountryAndStateOfResidenceInputsPresentational: React.FC<CountryAndStateOfResidenceInputsProps> = props => {
    const shouldShowStateSelection = !!props.selectedCountry && countryRequiresState(props.selectedCountry);
    return (
        <>
            <CountryOfResidenceInput
                inputName={props.countryInputName}
                validationErrors={props.validationErrors}
                optionsAreLoading={props.optionsAreLoading}
                options={props.countryOptions}
                value={props.selectedCountry}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                    const countryId = event.target.value;
                    const country = props.countryOptions.find(c => c.id === countryId);
                    const countryHasChanged = (props.selectedCountry && props.selectedCountry.id) !== countryId;
                    props.onChange(country, (!country || countryHasChanged) ? '' : props.selectedStateId);
                }}
                countryNamesLocale={props.namingLocale}
            />
            {shouldShowStateSelection && (
                <StateOfResidenceInput
                    inputName={props.stateInputName}
                    validationErrors={props.validationErrors}
                    optionsAreLoading={props.optionsAreLoading}
                    onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                        props.onChange(props.selectedCountry, event.target.value);
                    }}
                    country={props.selectedCountry}
                    valueId={props.selectedStateId}
                />
            )}
        </>
    );
};

export const CountryAndStateOfResidenceInputs = injectIntl(CountryAndStateOfResidenceInputsPresentational);
